import React from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import {ThemedText, ThemedView} from '@app/theme';
import InProgress from "@app/assets/svg/InProgress";

interface InProgressCardProps {
  visible: boolean;

}

const InProgressCard: React.FC<InProgressCardProps> = ({ visible }) => (
  <BottomSheetContainer
    isVisible={visible}
    dragComponent={undefined}
    closeOnBackdropPress={false}
    borderTopRightRadius={10}
    borderTopLeftRadius={10}
    containerStyle={{backgroundColor: '#fefefe'}}
  >
    <ThemedView alignItems={"center"} padding={"lg"}>
      <InProgress/>
      <ThemedText mt={"xl"} variant={"h4b"} mb={"sm"}>
        Waiting for response
      </ThemedText>
      <ThemedText variant={"b3r"} textAlign={"center"} mb={"xl"}>
        Please wait while we process your request
      </ThemedText>
    </ThemedView>
  </BottomSheetContainer>
);

export default InProgressCard; 